/**
 * @spec docs/specs/features/staking-position-ui.md
 * Application entry point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

function render() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Demo mode (`pnpm dev:demo`) installs mock data and a fake wallet before the
// first render. `__DEMO__` is a compile-time constant that vite.config.ts sets
// from `--mode demo` only; every other build replaces it with `false`, so the
// bundler drops this branch and the demo modules (CI checks the dist for them).
if (__DEMO__) {
  void import('./demo/boot').then(({ installDemo }) => {
    installDemo();
    render();
  });
} else {
  render();
}
